      <!-- VISUALIZE DISPLAY OF EVENT -->
      <div *ngIf="!loading">
        <div class="header">
          <mat-icon class="icon" (click)="close()">
            close
          </mat-icon>
        </div>
        <div >
          <app-event-form
          [state]="'create'"
          [initialDate]="initialDate"
          (saved)="closeDialog()"
          >

          </app-event-form>
        </div>
    </div>
    <div *ngIf="loading" class="loading">
      <mat-spinner color="accent" diameter="40"></mat-spinner>
    </div>